import React from "react";
import { Animated } from "react-native";
import { Container, Body, Author } from "./styles";

const Quote = ({
	body,
	author,
	opacity,
	translateY,
}: {
	body: string;
	author: string;
	opacity: Animated.Value;
	translateY: Animated.AnimatedInterpolation;
}) => {
	return (
		<Container
			style={{
				opacity,
				transform: [
					{
						translateY,
					},
				],
			}}>
			<Body type="h2">{`“${body}”`}</Body>
			<Author>{`—${author}`}</Author>
		</Container>
	);
};

export default Quote;
